/**
 * SubmissionsPage: the user's own submissions to other people's bounties,
 * rendered at /account/submissions (nested under UserHomepage). Pure composition,
 * no local state or API calls: four components/SubheadedPage sections (pending/
 * validated, accepted, user rejected, ai rejected), each a
 * components/ItemCollection of type "user-submissions" filtered by statusType.
 * Data fetching happens inside ItemCollection.
 */
import ItemCollection from "@/components/ItemCollection";
import { SubheadedPage } from "@/components/SubheadedPage";

const SubmissionsPage: React.FC = () => {
    return (
        <div className="flex flex-col w-full pb-16">
            <SubheadedPage heading="pending submissions">
                <ItemCollection
                    type="user-submissions"
                    itemType="submission"
                    format="row"
                    statusType="validated"
                    emptyStateText="no pending submissions"
                />
            </SubheadedPage>
            <SubheadedPage heading="accepted submissions">
                <ItemCollection
                    type="user-submissions"
                    itemType="submission"
                    format="row"
                    statusType="accepted"
                    emptyStateText="no accepted submissions"
                />
            </SubheadedPage>
            <SubheadedPage heading="user rejected submissions">
                <ItemCollection
                    type="user-submissions"
                    itemType="submission"
                    format="row"
                    statusType="rejected"
                    emptyStateText="no user rejected submissions"
                />
            </SubheadedPage>
            <SubheadedPage heading="ai rejected submissions">
                <ItemCollection
                    type="user-submissions"
                    itemType="submission"
                    format="row"
                    statusType="ai_rejected"
                    emptyStateText="no ai rejected submissions"
                />
            </SubheadedPage>
        </div>
    );
};

export default SubmissionsPage;
